import React from "react";
import Subscription from "../components/Subscription";

export default function subscription() {
  return <Subscription />;
}
